const getSortType = (type, column) => (type === 'ascending' ? `+${column}` : type === 'descending' ? `-${column}` : '');

export default getSortType;
